import { Skeleton } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { StatusGroup } from 'api/tasks';
import { StatusColors } from 'components/colors';
import { HelperText01, ProductiveHeading05 } from 'components/styles';
import { useProjectDetail } from 'data/projects';
import { useProjectFieldsQuery } from 'queries';
import { byFieldName } from 'utils/by-field-name';

const Title = styled.p`
  ${HelperText01};
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: space-between;
  margin-bottom: var(--spacing-03);

  .ant-tag {
    margin: 0;
  }
`;

const Value = styled.div<{ group?: StatusGroup }>`
  ${ProductiveHeading05};
  height: 24px;
  align-items: center;
  display: flex;
  color: ${({ group }) => {
    switch (group) {
      case StatusGroup.Blocked:
        return StatusColors.Blocked;
      case StatusGroup.Cancelled:
        return StatusColors.Cancelled;
      case StatusGroup.Completed:
        return StatusColors.Completed;
      case StatusGroup.InPlanning:
        return StatusColors.InPlanning;
      case StatusGroup.InProgress:
        return StatusColors.InProgress;
      case StatusGroup.Proposed:
        return StatusColors.Proposed;
      case StatusGroup.ToBeStaffed:
        return StatusColors.ToBeStaffed;
      case StatusGroup.Todo:
        return StatusColors.ToDo;
      default:
        return StatusColors.Default;
    }
  }};
`;

export const ProjectOverviewHighlightTileStatus: FC<{ projectId: number }> = ({
  projectId,
}) => {
  const { data: projectFields, isLoading } = useProjectFieldsQuery();
  const { data: project } = useProjectDetail(ProjectId(projectId));

  const projectStatusField = projectFields?.find((field) =>
    byFieldName(field, 'Status'),
  );

  const statusValue = project?.fields?.find(
    (f) => f.fieldId === projectStatusField?.fieldId,
  );

  const statusInOptions = statusValue?.metaData?.options
    ?.filter((e) => e.active)
    .find((e) => e.value === statusValue?.metaFieldValue?.value);

  return (
    <>
      <Title>
        <FormattedMessage id="status" />
      </Title>

      {isLoading ? (
        <Skeleton paragraph={false} />
      ) : (
        <Value
          group={statusInOptions?.group as StatusGroup}
          data-cy="status-card-value"
        >
          {statusInOptions?.label}
        </Value>
      )}
    </>
  );
};
